export default {
  message: {
    noData: "暫無數據",
  },
  header: {
    home: "首頁",
    anchor: "主播",
    schedule: "賽程",
    news: "資訊",
    subscribe: "訂閱",
    download: "下載APP",
    apply_anchor: "申請主播",
    login: "登入",
    register: "註冊",
    personal_center: "個人中心",
    logout: "退出登入",
  },
  footer: {
    pro_anchor_exclusive: "專業主播·獨家賽事",
    global_events: "全球賽事",
    hd_live: "高清直播",
    pro_anchor: "專業主播",
    massive_data: "海量數據",
    user_agreement: "用戶協議",
    privacy_policy: "隱私政策",
    disclaimer: "免責聲明",
    permission_details: "權限詳情",
    ios_download: "IOS下載",
    android_download: "Android下載",
    qr_code: "二維碼",
  },
  downloadTip: {
    online_service: "在線客服",
    download: "下載",
    qr_code: "二維碼",
    download_app: "下載APP",
    more_live: "更多比賽直播",
    cooperation: "合作",
    no_content: "暫無相關內容，敬請期待！",
  },
  findPassword: {
    title: "找回密碼",
    input_phone: "請輸入號碼",
    input_code: "請輸入驗證碼",
    input_password: "請輸入密碼",
    code_empty: "驗證碼不能為空",
    get_code: "獲取驗證碼",
    resend: "重新發送（{second}）",
    get_code_success: "獲取驗證碼成功",
    phone_warn: "請填寫正確格式的手機號",
    pass_warn: "密碼為6-20位字母數字組合！",
    find_now: "立即找回",
    success: "密碼修改成功，請重新登入！",
  },
  register: {
    title: "註冊",
    input_phone: "請輸入手機號",
    input_code: "請輸入驗證碼",
    input_password: "請輸入6-20位字母數字組合的密碼",
    code_warn: "請輸入格式正確的驗證碼",
    pass_warn: "請輸入6-20位字母數字組合的密碼",
    go_login: "去登入",
    register_and_login: "註冊並登入",
    get_code: "獲取驗證碼",
    resend: "重新發送（{second}）",
    get_code_success: "驗證碼發送成功，請注意查收",
    phone_warn: "請填寫正確格式的手機號",
    login_success: "登入成功",
  },
  mainTain: {
    img_alt: "圖片",
    system_maintain: "系統維護中...",
    maintain_words:
      "為了更好的為您服務，本網站正在升級維護中，因此帶來不便深表歉意",
  },
  login: {
    title: "登入",
    input_phone: "請輸入號碼",
    input_password: "請輸入密碼",
    register_now: "立即註冊",
    forget_password: "忘記密碼",
    login_btn: "登入",
    phone_warn: "請填寫正確格式的手機號",
    pass_warn: "密碼為6-20位字母數字組合！",
    phone_empty: "請填寫手機號",
    pass_empty: "請填寫密碼",
    login_success: "登入成功",
    pass_error: "密碼錯誤！",
  },
  livingRank: {
    gold_anchor: "金牌主播",
    anchor_recommend: "主播推薦",
    change_batch: "換一批",
    subscribe: "訂閱",
    subscribed: "已訂閱",
  },
  introduceLive: {
    live_recommend: "直播推薦",
    recommend: "推薦",
    足球: "足球",
    篮球: "籃球",
    电竞: "電競",
    网球: "網球",
    排球: "排球",
    乒乓球: "乒乓球",
    羽毛球: "羽毛球",
    板球: "板球",
    搏击: "搏擊",
    其他: "其他",
    icon_alt: "圖標",
  },
  tipBox: {
    success: "操作成功",
    login_success: "登入成功",
  },
  video: {
    enterStudio: "進入直播間",
    danmu: "彈幕",
    loading: "正在加載中...",
    download_app: "下載APP",
    more_live: "更多比賽直播",
    more_video: "更多比賽視頻",
    link_failed: "鏈接失敗，請重新加載",
    reload: "重新加載",
    danmu: "彈幕",
    enter_live: "進入直播間",
    drag_tip: "按住視頻可進行拖動",
    click_pause: "點擊暫停",
    click_play: "點擊播放",
    click_mute: "點擊靜音",
    cancel_mute: "取消靜音",
    click_fullscreen: "點擊全屏",
    exit_fullscreen: "退出全屏",
    load_error: "加載錯誤",
  },
  home: {
    announcement: "公告",
    match_recommend: "賽事推薦",
    icon_alt: "圖標",
    living: "直播中",
    book_now: "立即預約",
    ended: "已結束",
    match_ended: "比賽已結束！",
    coming_soon: "敬請期待！",
    not_started: "未開賽",
    delayed: "已延期",
    deleted: "已刪除",
  },
  myLiving: {
    my_live: "我的直播",
    subscribe: "訂閱",
    exit_live: "退出直播",
    tips: "溫馨提示",
    obs_tip: "OBS或其他第三方直播軟件進行直播，推流成功後點擊開始直播",
    push_url: "推流地址",
    stream_name: "流名",
    copy: "點擊複製",
    start_live: "開始直播",
    live_notice: "直播公告",
    contact_us: "聯繫我們",
    copy_success: "複製成功快去聯繫主播吧！",
    copy_address_success: "複製地址成功",
    edit_notice_tip: "開啟直播後才可以修改直播資訊",
  },
  advisory: {
    related: "相關文章",
    recommend: "推薦資訊",
    more: "更多",
  },
  competition: {
    nav_0: "熱門賽程",
    nav_1: "全部賽程",
    nav_2: "我的預約",
    all_matches: "全部賽事",
    kill: "擊殺",
    economy: "經濟",
    tower: "推塔",
    dragon: "小龍",
    odds: "指數",
    analysis: "分析",
    ended: "已結束",
    not_started: "未開始",
    delayed: "已延期",
    deleted: "已刪除",
    match_num: "第{num}場",
    week: "星期",
    today: "今日",
    loading: "更多數據正在加載中...",
    no_more_data: "沒有更多數據了",
  },
  download: {
    scan_tip: "掃一掃下載體育直播APP",
    ios_download: "IOS下載",
    android_download: "Android下載",
    android_download2: "安卓下載",
    ios_guide: "查看ios安裝教程",
    global_matches: "全球賽事",
    hd_live: "高清直播",
    pro_live: "專業直播",
    mass_data: "海量數據",
  },
  giftItem: {
    send_gift: "送出{gift}",
  },
  live: {
    recommend: "推薦",
    推荐: "推薦",
    足球: "足球",
    篮球: "籃球",
    电竞: "電競",
    网球: "網球",
    排球: "排球",
    乒乓球: "乒乓球",
    羽毛球: "羽毛球",
    板球: "板球",
    搏击: "搏擊",
    全部: "全部",
    其他: "其他",
    icon_alt: "圖標",
    loading: "加載中...",
    no_more: "沒有更多數據了",
    load_more: "查看更多",
  },
  liveChat: {
    enter_room: "進入聊天室",
    anchor_offline: "主播已下播，不能發送聊天內容",
    room_closed: "聊天室已關閉",
    input_tip: "請輸入不超過30個字符的聊天內容...",
    please: "請先",
    login: "登入",
    send: "發送",
    new_msg: "有{num}新消息",
    welcome: "歡迎",
    iknow: "我知道了",
    muted_tip: "您已被禁言，請聯繫管理員！",
    force_offline: "您已被強制下播，請聯繫客服！",
    muted: "已被禁言",
    cleared: "聊天資訊已被清空",
    room_closed_try: "聊天室已關閉，請稍後再試！",
    loading: "聊天數據加載中，請稍後！",
    input_empty: "請輸入聊天內容！",
    room_opened: "聊天室已打開",
  },
  liveChat: {
    enter_room: "進入聊天室",
    anchor_offline: "主播已下播，不能發送聊天內容",
    room_closed: "聊天室已關閉",
    input_tip: "請輸入不超過30個字符的聊天內容...",
    please: "請先",
    login: "登入",
    send: "發送",
    new_msg: "有{num}新消息",
    welcome: "歡迎",
    iknow: "我知道了",
    muted_tip: "您已被禁言，請聯繫管理員！",
    force_offline: "您已被強制下播，請聯繫客服！",
    muted: "已被禁言",
    cleared: "聊天資訊已被清空",
    room_closed_try: "聊天室已關閉，請稍後再試！",
    loading: "聊天數據加載中，請稍後！",
    input_empty: "請輸入聊天內容！",
    room_opened: "聊天室已打開",
  },
  liveDetails: {
    resting: "主播休息中…",
    sports_live: "體育直播",
    share: "分享",
    share_tip: "呼喚小伙伴前來圍觀吧",
    copy: "複製",
    mobile_watch: "手機觀看",
    download_app_anytime: "下載APP隨時隨地",
    free_watch: "免費看賽事直播",
    qr_alt: "二維碼",
    people: "人",
    subscribe: "訂閱",
    subscribed: "已訂閱",
    anchor_offline: "主播已下播",
    recommend_live: "為你推薦直播",
    subscribe_tip: "訂閱主播可收到開播提醒",
    icon_alt: "圖標",
    live_notice: "直播公告",
    welcome: "歡迎來到{name}的直播間",
    contact_us: "聯繫我們",
    qq_wechat: "qq/微信",
    push_order: "主播推單",
    push_order_list: "推單列表",
    follow: "人跟單",
    oppose: "人反買",
    combo: "連擊",
    give: "贈送",
  },
  liveSettingDialog: {
    title: "直播設置",
    live_title: "直播標題",
    live_category: "直播分類",
    service_select: "客服選擇",
    cover_upload: "封面上傳",
    cover_tip: "封面建議大小為2MB，不上傳封面隨機截屏作為封面",
    live_notice: "直播公告",
    relate_title: "關聯賽事數據分析",
    just_live: "純粹開播",
    relate_live: "關聯比賽數據開播",
    not_started: "未開始",
    in_progress: "比賽中",
    team_logo: "隊標",
    contact_title: "聯繫方式",
    qq_number: "號碼",
    qq_placeholder: "請輸入您要添加的聯繫QQ號",
    show_status: "顯示狀態",
    hide_all: "隱藏全部",
    show_all: "顯示全部",
    show_copy: "顯示複製按鈕",
    close: "關閉",
  },
  personal: {
    account: "個人賬號",
    go_live: "我要直播",
    push_order: "我要推單",
    account_setting: "賬號設置",
    base_info: "基礎資料",
    change_avatar: "修改頭像",
    change_password: "修改密碼",
    change_skin: "切換皮膚",
    my_social: "我的社交",
    my_follow: "我的關注",
    my_fans: "我的粉絲",
    my_room: "我的房間",
    my_live_room: "我的直播間",
    my_live_record: "我的直播記錄",
    diamond: "鑽石",
    tip: "提示",
    switch_skin_tip: "是否切換{skin}皮膚？",
    cancel: "取消",
    confirm: "確定",
    unmute_tip: "確認是否解除該用戶禁言",
    save: "保存",
    upload_avatar: "上傳頭像",
    only_support: "(僅支持jpg、jpeg、png)",
    keep: "保存",
    cancel_follow: "取消關注",
    subscribe: "訂閱",
    unsubscribe: "取消訂閱",
    search: "搜索",
    start_time: "開始日期",
    end_time: "結束日期",
    query_time: "查詢時間",
    live_title: "直播標題",
    live_type: "直播類型",
    live_start: "開播時間",
    live_end: "結束時間",
    live_people: "房間人數",
    live_diamond: "鑽石",
    live: "一般直播",
    current_password: "當前密碼",
    new_password: "新密碼",
    confirm_password: "確認密碼",
    please_input: "請輸入",
    please_input_nickname: "請輸入暱稱",
    please_input_signature: "請輸入簽名",
    please_input_birthday: "請輸入生日",
    please_input_password: "請輸入當前密碼",
    please_input_new_password: "請輸入新密碼",
    please_input_confirm_password: "請輸入確認密碼",
    please_input_avatar: "請上傳需要修改的頭像圖片",
    please_input_sign: "請輸入簽名",
    please_input_room: "請輸入房間號",
    please_input_query: "請輸入查詢內容",
    gender_secret: "保密",
    gender_male: "男",
    gender_female: "女",
    nickname: "暱稱",
    gender: "性別",
    signature: "簽名",
    birthday: "生日",
    save_success: "保存成功",
    save_fail: "保存失敗",
    upload_success: "頭像上傳成功",
    upload_fail: "頭像上傳失敗，請重新上傳",
    password_success: "修改密碼成功",
    password_fail: "密碼為6-20位字母數字組合！",
    password_not_match: "新密碼與確認密碼不一致，請重新輸入",
    empty: "暫無數據",
    unmute: "解禁",
    status: "狀態",
    operation: "操作",
    anchor_name: "主播姓名",
    processed_user: "被處理人",
  },
  pushOrder: {
    list: "推單列表",
    add: "推單新增",
    id: "推送ID",
    category: "推單類型",
    select_category: "請選擇推單類型",
    status: "狀態",
    select_status: "請選擇推單狀態",
    desc: "推單描述",
    input_desc: "請輸入推單描述",
    buy: "跟單",
    oppose: "反買",
    operate: "操作",
    edit: "編輯",
    delete: "刪除",
    confirm_delete: "您確定刪除這條數據嗎？",
    reset: "重置",
    search: "搜索",
    searching: "搜索中",
    submit: "立即提交",
    submitting: "提交中",
  },
  subscription: {
    living_now: "正在直播中",
    not_live: "暫未開播",
    please_login: "請先登入！",
    login: "登入",
    no_subscribe_live: "暫無訂閱直播，快去訂閱吧！",
    no_subscribe_anchor: "暫無訂閱主播，快去訂閱吧！",
  },
};



// WEBPACK FOOTER //
// ./src/lang/zh-TW.js